import { MaterialName, MATERIALS } from "./materials"
import { Material } from "./materials/material"

export type TissueLabelDisplayName = 
"Background" |
"Right kidney" |
"Left kidney" |
"Excretory" |
"Right excretory" |
"Right excretory" |
"Left excretory" |
"Left excretory" |
"Artery" |
"Vein" |
"Spleen" |
"Bone" |
"Liver" |
"Stomach" |
"Bladder" |
"Sinus fat" |
"Kidney stone" |
"Stent" |
"Implant" |
"Portal vein" |
"Bile duct" |
"Gall bladder" |
"Lung" |
"Left Lower Lobe - LL" |
"Left Upper Lobe - LU" |
"Right Lower Lobe - RL" |
"Right Middle Lobe - RM" |
"Right Upper Lobe - RU" |
"Left Lower Lobe - LL" |
"Left Upper Lobe - LU" |
"Right Lower Lobe - RL" |
"Right Middle Lobe - RM" |
"Right Upper Lobe - RU" |
"Lobe segment" |
"Airway" |
"Airway detail" |
"Artery detail" |
"Vein detail" |
"Coronary artery" |
"Artery uncertain" |
"Vein uncertain" |
"Adrenal gland" |
"Right psoas" |
"Left psoas" |
"Rectus abdominis" |
"Diaphragm crus" |
"Thoracic duct" |
"Skin" |
"Body fat" |
"Left transverse abs" |
"Right transverse abs" |
"Azygos vein" |
"Colon" |
"Oesophagus" |
"Bowel" |
"Pulmonary artery" |
"Pulmonary vein" |
"Nerve" |
"Nerve" |
"Neurovascular bundle" |
"Prostate" |
"Pancreas" |
"Urethra" |
"Sphincter" |
"Seminal vesicles" |
"Ovary" |
"Uterus" |
"Vagina" |
"Sacrum" |
"Right pelvis" |
"Left pelvis" |
"Mesorectum" |
"Rectum" |
"Internal Sphincter" |
"External sphincter" |
"Fistula" |
"Right muscle" |
"Left muscle" |
"SLAM" |
"Fibroid" |
"Central zone" |
"Peripheral zone" |
"Transitional zone" |
"AFS" |
"Myometrium" |
"Fallopian Tubes" |
"Ureter" |
"Endometrium" |
"Lymph" |
"Calcification" |
"Thyroid" |
"Pterygoid muscle" |
"Styloglossus muscle" |
"Stylohyoid muscle" |
"Stylopharyngeus muscle" |
"Tongue" |
"Heart" |
"Aorta" |
"S1 (caudate" |
"S2" |
"S3" |
"S4a" |
"S4b (quadrate" |
"S5" |
"S6" |
"S7" |
"S8" |
"Left Lobe" |
"Right Lobe" |
"Tumour" |
"PIRADS 3" |
"PIRADS 3 Extern" |
"Uncertain lesion" |
"PIRADS 4" |
"PIRADS 4 Extern" |
"PIRADS 5" |
"PIRADS 5 Extern" |
"Tethering" |
"Fluid" |
"Cyst" |
"Cyst" |
"Cartilage" |
"Left Atrium" |
"Left Ventricle" |
"Right Atrium" |
"Right Ventricle" |
"Myocardium" |
"Centreline" |
"Unknown" |
"RU Apical S1" |
"RU Post S2" |
"RU Ant S3" |
"RM Lat S4" |
"RM Med S5" |
"RL Sup S6" |
"RL Med S7" |
"RL Ant S8" |
"RL Lat S9" |
"RL Post S10" |
"LU Apical S1" |
"LU Post S2" |
"LU Ant S3" |
"LU Ling S4" |
"LU Inf  S5" |
"LL Sup S6" |
"LL Med S7" |
"LL Ant S8" |
"LL Basal S9" |
"LL Post S10" |
"Seg LU a" |
"Seg LU b" |
"Seg LU c" |
"Seg LU d" |
"Seg LU e" |
"Seg LU f" |
"Seg LU g" |
"Seg LU h" |
"Seg LU i" |
"Seg LU j" |
"Seg LL k" |
"Seg LL l" |
"Seg LL m" |
"Seg LL n" |
"Seg LL o" |
"Seg LL p" |
"Seg LL q" |
"Seg LL r" |
"Seg LL s" |
"Seg LL t" |
"Seg RU a" |
"Seg RU b" |
"Seg RU c" |
"Seg RU d" |
"Seg RU e" |
"Seg RU f" |
"Seg RU g" |
"Seg RU h" |
"Seg RU i" |
"Seg RU j" |
"Seg RM k" |
"Seg RM l" |
"Seg RM m" |
"Seg RM n" |
"Seg RM o" |
"Seg RM \u0398" |
"Seg RM \u03B2" |
"Seg RM \u039B" |
"Seg RM \u03A9" |
"Seg RM \u03B1" |
"Seg RL p" |
"Seg RL q" |
"Seg RL r" |
"Seg RL s" |
"Seg RL t" |
"Seg RL u" |
"Seg RL v" |
"Seg RL w" |
"Seg RL x" |
"Seg RL y" |
"Artery Right Apical S1" |
"Artery Right Post S2" |
"Artery Right Ant S3" |
"Artery Right Lat S4" |
"Artery Right Med S5" |
"Artery Right Sup S6" |
"Artery Right Med S7" |
"Artery Right Ant S8" |
"Artery Right Lat S9" |
"Artery Right Post S10" |
"Artery Left Apical S1" |
"Artery Left Post S2" |
"Artery Left Ant S3" |
"Artery Left Ling S4" |
"Artery Left Inf S5" |
"Artery Left Sup S6" |
"Artery Left Med S7" |
"Artery Left Ant S8" |
"Artery Left Basal S9" |
"Artery Left Post S10" |
"Gastroduodenal artery (GDA)" |
"Middle Colic (MCA)" |
"Right Colic (RCA)" |
"Ileocolic (ICA)" |
"First jejunal (J1A)" |
"Inferior mesenteric (IMA)" |
"Uper rectal (URA)" |
"Left colic (LCA)" |
"Sigmoid (SA)" |
"Second jejunal (J2A)" |
"Superior mesenteric artery (SMA)" |
"Art LU a" |
"Art LU b" |
"Art LU c" |
"Art LU d" |
"Art LU e" |
"Art LU f" |
"Art LU g" |
"Art LU h" |
"Art LU i" |
"Art LU j" |
"Art LL k" |
"Art LL l" |
"Art LL m" |
"Art LL n" |
"Art LL o" |
"Art LL p" |
"Art LL q" |
"Art LL r" |
"Art LL s" |
"Art LL t" |
"Art RU a" |
"Art RU b" |
"Art RU c" |
"Art RU d" |
"Art RU e" |
"Art RU f" |
"Art RU g" |
"Art RU h" |
"Art RU i" |
"Art RU j" |
"Art RM k" |
"Art RM l" |
"Art RM m" |
"Art RM n" |
"Art RM o" |
"Art RM \u0398" |
"Art RM \u03B2" |
"Art RM \u039B" |
"Art RM \u03A9" |
"Art RM \u03B1" |
"Art RL p" |
"Art RL q" |
"Art RL r" |
"Art RL s" |
"Art RL t" |
"Art RL u" |
"Art RL v" |
"Art RL w" |
"Art RL x" |
"Art RL y" |
"Inferior mesenteric (IMV)" |
"First jejunal (J1V)" |
"Middle Colic (MCV)" |
"Right gastroepiploic (RGEV)" |
"Ilecolic (ICV)" |
"Henle (GTH)" |
"Second jejunal (J2V)" |
"Ileal (IL)" |
"Third jejunal (J3V)" |
"Inferior pancreatoduodenal (IPDV)" |
"Superior mesenteric vein (SMV)" |
"Right colic vein (RCV)" |
"Lobe Kidney (segments)" |
"PV1" |
"PV2" |
"PV3" |
"PV4a" |
"PV4b" |
"PV5" |
"PV6" |
"PV7" |
"PV8" |
"Urine"

export interface TissueLabelParams {
  readonly displayName: TissueLabelDisplayName
  readonly index: number
  readonly show?: boolean
  readonly material: MaterialName
}

// order by index to reduce chance of index clash
export const TISSUE_LABEL_PARAMSS = {
  background:                  {displayName: "Background",                        index: 0,   material: 'background',                     show: false}, // used mainly for name in menus
  rightKidney:                 {displayName: "Right kidney",                      index: 1,   material: 'kidneyBrown',                    show: false},
  leftKidney:                  {displayName: "Left kidney",                       index: 2,   material: 'kidneyPink',                     show: false},
  excretory:                   {displayName: "Excretory",                         index: 3,   material: 'excretoryGold',                  },
  excretoryRight:              {displayName: "Right excretory",                   index: 3,   material: 'excretoryGold',                  },
  excretoryRightColorectal:    {displayName: "Right excretory",                   index: 3,   material: 'seaGreen',                       },
  excretoryLeft:               {displayName: "Left excretory",                    index: 4,   material: 'excretoryGold',                  },
  excretoryLeftColorectal:     {displayName: "Left excretory",                    index: 4,   material: 'seaGreenDark',                   },
  artery:                      {displayName: "Artery",                            index: 5,   material: 'arteryRed',                      },
  vein:                        {displayName: "Vein",                              index: 6,   material: 'veinBlue',                       },
  spleen:                      {displayName: "Spleen",                            index: 7,   material: 'spleenPurple',                   },
  bone:                        {displayName: "Bone",                              index: 8,   material: 'nerveGold',                      },
  liver:                       {displayName: "Liver",                             index: 9,   material: 'liverPurple',                    },
  stomach:                     {displayName: "Stomach",                           index: 10,  material: 'stomachGeraldine',               },
  bladder:                     {displayName: "Bladder",                           index: 11,  material: 'bladderOrange',                  },
  renalSinusFat:               {displayName: "Sinus fat",                         index: 12,  material: 'renalSinusFatTangerine',         show: false},
  stone:                       {displayName: "Kidney stone",                      index: 13,  material: 'stoneTan',                       },
  stent:                       {displayName: "Stent",                             index: 14,  material: 'stentGrey',                      },
  implant:                     {displayName: "Implant",                           index: 15,  material: 'arteryRed',                      },
  portalVein:                  {displayName: "Portal vein",                       index: 17,  material: 'portalVeinCyan',                 },
  bileDuct:                    {displayName: "Bile duct",                         index: 18,  material: 'bileDuctGreen',                  },
  gallBladder:                 {displayName: "Gall bladder",                      index: 19,  material: 'gallBladderGreen',               },
  lung:                        {displayName: "Lung",                              index: 20,  material: 'lungWhole',                      },
  lobeLeftInferior:            {displayName: "Left Lower Lobe - LL",              index: 21,  material: 'lobeLeftInferiorColour'          },
  lobeLeftSuperior:            {displayName: "Left Upper Lobe - LU",              index: 22,  material: 'lobeLeftSuperiorColour',         },
  lobeRightInferior:           {displayName: "Right Lower Lobe - RL",             index: 23,  material: 'lobeRightInferiorColour',        },
  lobeRightMedial:             {displayName: "Right Middle Lobe - RM",            index: 24,  material: 'lobeRightMedialColour',          },
  lobeRightSuperior:           {displayName: "Right Upper Lobe - RU",             index: 25,  material: 'lobeRightSuperiorColour',        },
  lobeLeftInferiorCurie:       {displayName: "Left Lower Lobe - LL",              index: 21,  material: 'lobeLeftInferiorColour'          },
  lobeLeftSuperiorCurie:       {displayName: "Left Upper Lobe - LU",              index: 22,  material: 'lobeLeftSuperiorColour',         },
  lobeRightInferiorCurie:      {displayName: "Right Lower Lobe - RL",             index: 23,  material: 'lobeRightInferiorColour',        },
  lobeRightMedialCurie:        {displayName: "Right Middle Lobe - RM",            index: 24,  material: 'lobeRightMedialColour',          },
  lobeRightSuperiorCurie:      {displayName: "Right Upper Lobe - RU",             index: 25,  material: 'lobeRightSuperiorColour',        },
  lobeSegment:                 {displayName: "Lobe segment",                      index: 29,  material: 'lobeSegmentGrey',                },
  airway:                      {displayName: "Airway",                            index: 30,  material: 'airwayYellow',                   },
  airwayDetail:                {displayName: "Airway detail",                     index: 31,  material: 'airwayOrange',                   },
  arteryDetail:                {displayName: "Artery detail",                     index: 32,  material: 'muscleRed',                      },
  veinDetail:                  {displayName: "Vein detail",                       index: 33,  material: 'veinDetailBlue',                 },
  coronaryArtery:              {displayName: "Coronary artery",                   index: 34,  material: 'arteryUncertainMaroon',          },
  arteryUncertain:             {displayName: "Artery uncertain",                  index: 35,  material: 'arteryUncertainMaroon',          },
  veinUncertain:               {displayName: "Vein uncertain",                    index: 36,  material: 'veinUncertainDarkBlue',          },
  adrenalGland:                {displayName: "Adrenal gland",                     index: 37,  material: 'adrenalMustard',                 },
  psoasRight:                  {displayName: "Right psoas",                       index: 40,  material: 'muscleRed',                      },
  psoasLeft:                   {displayName: "Left psoas",                        index: 41,  material: 'muscleRed',                      }, // TODO: change this colour to distinguish from right
  rectusAbdominis:             {displayName: "Rectus abdominis",                  index: 42,  material: 'rectusAbdominisRed',             },
  crus:                        {displayName: "Diaphragm crus",                    index: 43,  material: 'crusColour',                     },
  thoracicDuct:                {displayName: "Thoracic duct",                     index: 44,  material: 'thoracicDuctColour',             },
  skin:                        {displayName: "Skin",                              index: 45,  material: 'skinColour',                     },
  bodyFat:                     {displayName: "Body fat",                          index: 46,  material: 'bodyChartreuse',                 },
  leftTransverseAbs:           {displayName: "Left transverse abs",               index: 47,  material: 'transverseAbsOrange',            },
  rightTransverseAbs:          {displayName: "Right transverse abs",              index: 48,  material: 'transverseAbsOrange',            },
  azygosVein:                  {displayName: "Azygos vein",                       index: 49,  material: 'portalVeinCyan',                 },
  colon:                       {displayName: "Colon",                             index: 50,  material: 'heartPurple',                    },
  oesophagus:                  {displayName: "Oesophagus",                        index: 51,  material: 'oesophagusColour',               },
  bowel:                       {displayName: "Bowel",                             index: 52,  material: 'bowelPink',                      },
  pulmonaryArtery:             {displayName: "Pulmonary artery",                  index: 53,  material: 'veinUncertainDarkBlue',          },
  pulmonaryVein:               {displayName: "Pulmonary vein",                    index: 54,  material: 'rectumPink',                     },
  nerve:                       {displayName: "Nerve",                             index: 59,  material: 'nervePink',                      },
  nerveColorectal:             {displayName: "Nerve",                             index: 59,  material: 'nerveGold',                      },
  prostateNeurovascularBundle: {displayName: "Neurovascular bundle",              index: 59,  material: 'nervePink',                      },
  prostate:                    {displayName: "Prostate",                          index: 60,  material: 'prostateBlue',                   },
  pancreas:                    {displayName: "Pancreas",                          index: 61,  material: 'pancreasSaffron',                },
  urethra:                     {displayName: "Urethra",                           index: 62,  material: 'heartPurple',                    },
  urethralSphincter:           {displayName: "Sphincter",                         index: 63,  material: 'muscleRed',                      },
  seminalVesicle:              {displayName: "Seminal vesicles",                  index: 64,  material: 'seminalVesicleColour',           },
  ovary:                       {displayName: "Ovary",                             index: 65,  material: 'ovaryPink',                      },
  uterus:                      {displayName: "Uterus",                            index: 66,  material: 'uterusPink',                     },
  vagina:                      {displayName: "Vagina",                            index: 67,  material: 'default',                        },
  sacrum:                      {displayName: "Sacrum",                            index: 68,  material: 'sacrumColour',                   },
  rightPelvis:                 {displayName: "Right pelvis",                      index: 69,  material: 'pelvisRightColour',              },
  leftPelvis:                  {displayName: "Left pelvis",                       index: 70,  material: 'pelvisLeftColour',               },
  mesorectum:                  {displayName: "Mesorectum",                        index: 71,  material: 'mesorectumYellow',               },
  rectum:                      {displayName: "Rectum",                            index: 72,  material: 'rectumPink',                     },
  sphincterInternal:           {displayName: "Internal Sphincter",                index: 73,  material: 'bladderOrange',                  },
  sphincterExternal:           {displayName: "External sphincter",                index: 74,  material: 'arteryRed',                      },
  fistula:                     {displayName: "Fistula",                           index: 75,  material: 'default',                        },
  rightMuscle:                 {displayName: "Right muscle",                      index: 76,  material: 'muscleRed',                      },
  leftMuscle:                  {displayName: "Left muscle",                       index: 77,  material: 'muscleRed',                      },
  slam:                        {displayName: "SLAM",                              index: 78,  material: 'slamPurple',                     }, // Sacotuberous Ligaments And (coccygeal) Muscle
  fibroid:                     {displayName: "Fibroid",                           index: 79,  material: 'slamPurple',                     },
  prostateCentralZone:         {displayName: "Central zone",                      index: 80,  material: 'prostateCentralZoneColour',      },
  prostatePeripheralZone:      {displayName: "Peripheral zone",                   index: 81,  material: 'prostatePeripheralZoneColour',   },
  prostateTransitionalZone:    {displayName: "Transitional zone",                 index: 82,  material: 'prostateTransitionalZoneColour', },
  prostateAFS:                 {displayName: "AFS",                               index: 83,  material: 'prostateAFSColour',              },
  myometrium:                  {displayName: "Myometrium",                        index: 86,  material: 'kidneyBrown',                    },
  fallopianTubes:              {displayName: "Fallopian Tubes",                   index: 87,  material: 'mesorectumYellow',               },
  ureter:                      {displayName: "Ureter",                            index: 88,  material: 'excretoryGold',                  },
  endometrium:                 {displayName: "Endometrium",                       index: 89,  material: 'lymphPink',                      },
  lymph:                       {displayName: "Lymph",                             index: 90,  material: 'lymphPink',                      },
  calcification:               {displayName: "Calcification",                     index: 91,  material: 'calcificationColour',            },
  thyroid:                     {displayName: "Thyroid",                           index: 92,  material: 'nerveGold',                      },
  musclePterygoid:             {displayName: "Pterygoid muscle",                  index: 93,  material: 'kidneyBrown',                    },
  muscleStyloglossus:          {displayName: "Styloglossus muscle",               index: 94,  material: 'arteryUncertainMaroon',          },
  muscleStylohyoid:            {displayName: "Stylohyoid muscle",                 index: 95,  material: 'excretoryGold',                  },
  muscleStylopharyngeus:       {displayName: "Stylopharyngeus muscle",            index: 96,  material: 'cystPurple',                     },
  muscleTongue:                {displayName: "Tongue",                            index: 97,  material: 'renalSinusFatTangerine',         },
  heart:                       {displayName: "Heart",                             index: 98,  material: 'heartPurple',                    },
  aorta:                       {displayName: "Aorta",                             index: 99,  material: 'muscleRed',                      },
  liverSegment1:               {displayName: "S1 (caudate",                       index: 100, material: 's1',                             },
  liverSegment2:               {displayName: "S2",                                index: 101, material: 's2',                             },
  liverSegment3:               {displayName: "S3",                                index: 102, material: 's3',                             },
  liverSegment4a:              {displayName: "S4a",                               index: 103, material: 's4',                             },
  liverSegment4b:              {displayName: "S4b (quadrate",                     index: 104, material: 's5',                             },
  liverSegment5:               {displayName: "S5",                                index: 105, material: 's6',                             },
  liverSegment6:               {displayName: "S6",                                index: 106, material: 's7',                             },
  liverSegment7:               {displayName: "S7",                                index: 107, material: 's9',                             },
  liverSegment8:               {displayName: "S8",                                index: 108, material: 's10',                            },
  liverLobeLeft:               {displayName: "Left Lobe",                         index: 109, material: 'kidneyPink',                     },
  liverLobeRight:              {displayName: "Right Lobe",                        index: 110, material: 'kidneyBrown',                    },
  tumour:                      {displayName: "Tumour",                            index: 111, material: 'tumourGreen',                    },
  tumourPIRADS3:               {displayName: "PIRADS 3",                          index: 111, material: 'tumourGreen',                    },
  tumourPIRADS3External:       {displayName: "PIRADS 3 Extern",                   index: 112, material: 'tumourDarkGreen',                },
  lesionUncertain:             {displayName: "Uncertain lesion",                  index: 113, material: 'lesionUncertainOrange',          },
  tumourPIRADS4:               {displayName: "PIRADS 4",                          index: 114, material: 'tumourYellow',                   },
  tumourPIRADS4External:       {displayName: "PIRADS 4 Extern",                   index: 115, material: 'tumourDarkYellow',               },
  tumourPIRADS5:               {displayName: "PIRADS 5",                          index: 116, material: 'tumourRed',                      },
  tumourPIRADS5External:       {displayName: "PIRADS 5 Extern",                   index: 117, material: 'tumourDarkRed',                  },
  tethering:                   {displayName: "Tethering",                         index: 118, material: 'tetheringGreen',                 },
  fluid:                       {displayName: "Fluid",                             index: 119, material: 'portalVeinCyan',                 },
  cyst:                        {displayName: "Cyst",                              index: 121, material: 'cystPurple',                     },
  cystGynecology:              {displayName: "Cyst",                              index: 121, material: 'spleenPurple',                   },
  cartilage:                   {displayName: "Cartilage",                         index: 130, material: 'cystPurple',                     },
  heartAtriumLeft:             {displayName: "Left Atrium",                       index: 131, material: 'airwayOrange',                   },
  heartVentricleLeft:          {displayName: "Left Ventricle",                    index: 132, material: 'airwayYellow',                   },
  heartAtriumRight:            {displayName: "Right Atrium",                      index: 133, material: 'heartPurple',                    },
  heartVentricleRight:         {displayName: "Right Ventricle",                   index: 134, material: 'heartVentricleRightColour',      },
  heartMyocardium:             {displayName: "Myocardium",                        index: 135, material: 'heartMyocardiumColour',          },
  vesselCentreline:            {displayName: "Centreline",                        index: 149, material: 'liverPurple',                    },
  unknown:                     {displayName: "Unknown",                           index: 150, material: 'liverPurple',                    },
  segmentRightS1:              {displayName: "RU Apical S1",                      index: 151, material: 's1',                             },
  segmentRightS2:              {displayName: "RU Post S2",                        index: 152, material: 's2',                             },
  segmentRightS3:              {displayName: "RU Ant S3",                         index: 153, material: 's3',                             },
  segmentRightS4:              {displayName: "RM Lat S4",                         index: 154, material: 's4',                             },
  segmentRightS5:              {displayName: "RM Med S5",                         index: 155, material: 's5',                             },
  segmentRightS6:              {displayName: "RL Sup S6",                         index: 156, material: 's6',                             },
  segmentRightS7:              {displayName: "RL Med S7",                         index: 157, material: 's7',                             },
  segmentRightS8:              {displayName: "RL Ant S8",                         index: 158, material: 's10',                            },
  segmentRightS9:              {displayName: "RL Lat S9",                         index: 159, material: 's9',                             },
  segmentRightS10:             {displayName: "RL Post S10",                       index: 160, material: 's8',                             },
  segmentLeftS1:               {displayName: "LU Apical S1",                      index: 161, material: 's1',                             },
  segmentLeftS2:               {displayName: "LU Post S2",                        index: 162, material: 's2',                             },
  segmentLeftS3:               {displayName: "LU Ant S3",                         index: 163, material: 's3',                             },
  segmentLeftS4:               {displayName: "LU Ling S4",                        index: 164, material: 's4',                             },
  segmentLeftS5:               {displayName: "LU Inf  S5",                        index: 165, material: 's5',                             },
  segmentLeftS6:               {displayName: "LL Sup S6",                         index: 166, material: 's6',                             },
  segmentLeftS7:               {displayName: "LL Med S7",                         index: 167, material: 's7',                             },
  segmentLeftS8:               {displayName: "LL Ant S8",                         index: 168, material: 's10',                            },
  segmentLeftS9:               {displayName: "LL Basal S9",                       index: 169, material: 's9',                             },
  segmentLeftS10:              {displayName: "LL Post S10",                       index: 170, material: 's8',                             },
  segmentS1:                   {displayName: "Seg LU a",                          index: 151, material: 's1',                             },
  segmentS2:                   {displayName: "Seg LU b",                          index: 152, material: 's2',                             },
  segmentS3:                   {displayName: "Seg LU c",                          index: 153, material: 's3',                             },
  segmentS4:                   {displayName: "Seg LU d",                          index: 154, material: 's4',                             },
  segmentS5:                   {displayName: "Seg LU e",                          index: 155, material: 's5',                             },
  segmentS6:                   {displayName: "Seg LU f",                          index: 156, material: 's6',                             },
  segmentS7:                   {displayName: "Seg LU g",                          index: 157, material: 's7',                             },
  segmentS8:                   {displayName: "Seg LU h",                          index: 158, material: 's8',                             },
  segmentS9:                   {displayName: "Seg LU i",                          index: 159, material: 's9',                             },
  segmentS10:                  {displayName: "Seg LU j",                          index: 160, material: 's10',                            },
  segmentS11:                  {displayName: "Seg LL k",                          index: 161, material: 's1',                             },
  segmentS12:                  {displayName: "Seg LL l",                          index: 162, material: 's2',                             },
  segmentS13:                  {displayName: "Seg LL m",                          index: 163, material: 's3',                             },
  segmentS14:                  {displayName: "Seg LL n",                          index: 164, material: 's4',                             },
  segmentS15:                  {displayName: "Seg LL o",                          index: 165, material: 's5',                             },
  segmentS16:                  {displayName: "Seg LL p",                          index: 166, material: 's6',                             },
  segmentS17:                  {displayName: "Seg LL q",                          index: 167, material: 's7',                             },
  segmentS18:                  {displayName: "Seg LL r",                          index: 168, material: 's8',                             },
  segmentS19:                  {displayName: "Seg LL s",                          index: 169, material: 's9',                             },
  segmentS20:                  {displayName: "Seg LL t",                          index: 170, material: 's10',                            },
  segmentS21:                  {displayName: "Seg RU a",                          index: 171, material: 's1',                             },
  segmentS22:                  {displayName: "Seg RU b",                          index: 172, material: 's2',                             },
  segmentS23:                  {displayName: "Seg RU c",                          index: 173, material: 's3',                             },
  segmentS24:                  {displayName: "Seg RU d",                          index: 174, material: 's4',                             },
  segmentS25:                  {displayName: "Seg RU e",                          index: 175, material: 's5',                             },
  segmentS26:                  {displayName: "Seg RU f",                          index: 176, material: 's6',                             },
  segmentS27:                  {displayName: "Seg RU g",                          index: 177, material: 's7',                             },
  segmentS28:                  {displayName: "Seg RU h",                          index: 178, material: 's8',                             },
  segmentS29:                  {displayName: "Seg RU i",                          index: 179, material: 's9',                             },
  segmentS30:                  {displayName: "Seg RU j",                          index: 180, material: 's10',                            },
  segmentS31:                  {displayName: "Seg RM k",                          index: 181, material: 's1',                             },
  segmentS32:                  {displayName: "Seg RM l",                          index: 182, material: 's2',                             },
  segmentS33:                  {displayName: "Seg RM m",                          index: 183, material: 's3',                             },
  segmentS34:                  {displayName: "Seg RM n",                          index: 184, material: 's4',                             },
  segmentS35:                  {displayName: "Seg RM o",                          index: 185, material: 's5',                             },
  segmentS36:                  {displayName: "Seg RM \u0398",                     index: 186, material: 's6',                             },
  segmentS37:                  {displayName: "Seg RM \u03B2",                     index: 187, material: 's7',                             },
  segmentS38:                  {displayName: "Seg RM \u039B",                     index: 188, material: 's8',                             },
  segmentS39:                  {displayName: "Seg RM \u03A9",                     index: 189, material: 's9',                             },
  segmentS40:                  {displayName: "Seg RM \u03B1",                     index: 190, material: 's10',                            },
  segmentS41:                  {displayName: "Seg RL p",                          index: 191, material: 's1',                             },
  segmentS42:                  {displayName: "Seg RL q",                          index: 192, material: 's2',                             },
  segmentS43:                  {displayName: "Seg RL r",                          index: 193, material: 's3',                             },
  segmentS44:                  {displayName: "Seg RL s",                          index: 194, material: 's4',                             },
  segmentS45:                  {displayName: "Seg RL t",                          index: 195, material: 's5',                             },
  segmentS46:                  {displayName: "Seg RL u",                          index: 196, material: 's6',                             },
  segmentS47:                  {displayName: "Seg RL v",                          index: 197, material: 's7',                             },
  segmentS48:                  {displayName: "Seg RL w",                          index: 198, material: 's8',                             },
  segmentS49:                  {displayName: "Seg RL x",                          index: 199, material: 's9',                             },
  segmentS50:                  {displayName: "Seg RL y",                          index: 200, material: 's10',                            },
  arteryRightS1:               {displayName: "Artery Right Apical S1",            index: 201, material: 'a1segmentRight',                 },
  arteryRightS2:               {displayName: "Artery Right Post S2",              index: 202, material: 'a2segmentRight',                 },
  arteryRightS3:               {displayName: "Artery Right Ant S3",               index: 203, material: 'a3segmentRight',                 },
  arteryRightS4:               {displayName: "Artery Right Lat S4",               index: 204, material: 'a4segmentRight',                 },
  arteryRightS5:               {displayName: "Artery Right Med S5",               index: 205, material: 'a5segmentRight',                 },
  arteryRightS6:               {displayName: "Artery Right Sup S6",               index: 206, material: 'a6segmentRight',                 },
  arteryRightS7:               {displayName: "Artery Right Med S7",               index: 207, material: 'a7segmentRight',                 },
  arteryRightS8:               {displayName: "Artery Right Ant S8",               index: 208, material: 'a8segmentRight',                 },
  arteryRightS9:               {displayName: "Artery Right Lat S9",               index: 209, material: 'a9segmentRight',                 },
  arteryRightS10:              {displayName: "Artery Right Post S10",             index: 210, material: 'a10segmentRight',                },
  arteryLeftS1:                {displayName: "Artery Left Apical S1",             index: 211, material: 'a1segmentLeft',                  },
  arteryLeftS2:                {displayName: "Artery Left Post S2",               index: 212, material: 'a2segmentLeft',                  },
  arteryLeftS3:                {displayName: "Artery Left Ant S3",                index: 213, material: 'a3segmentLeft',                  },
  arteryLeftS4:                {displayName: "Artery Left Ling S4",               index: 214, material: 'a4segmentLeft',                  },
  arteryLeftS5:                {displayName: "Artery Left Inf S5",                index: 215, material: 'a5segmentLeft',                  },
  arteryLeftS6:                {displayName: "Artery Left Sup S6",                index: 216, material: 'a6segmentLeft',                  },
  arteryLeftS7:                {displayName: "Artery Left Med S7",                index: 217, material: 'a7segmentLeft',                  },
  arteryLeftS8:                {displayName: "Artery Left Ant S8",                index: 218, material: 'a8segmentLeft',                  },
  arteryLeftS9:                {displayName: "Artery Left Basal S9",              index: 219, material: 'a9segmentLeft',                  },
  arteryLeftS10:               {displayName: "Artery Left Post S10",              index: 220, material: 'a10segmentLeft',                 },
  arteryS1:                    {displayName: "Gastroduodenal artery (GDA)",       index: 201, material: 'a1segmentRight',                 },
  arteryS2:                    {displayName: "Middle Colic (MCA)",                index: 202, material: 'a2segmentRight',                 },
  arteryS3:                    {displayName: "Right Colic (RCA)",                 index: 203, material: 'a3segmentRight',                 },
  arteryS4:                    {displayName: "Ileocolic (ICA)",                   index: 204, material: 'a4segmentRight',                 },
  arteryS5:                    {displayName: "First jejunal (J1A)",               index: 205, material: 'a5segmentRight',                 },
  arteryS6:                    {displayName: "Inferior mesenteric (IMA)",         index: 206, material: 'a6segmentRight',                 },
  arteryS7:                    {displayName: "Uper rectal (URA)",                 index: 207, material: 'a7segmentRight',                 },
  arteryS8:                    {displayName: "Left colic (LCA)",                  index: 208, material: 'a8segmentRight',                 },
  arteryS9:                    {displayName: "Sigmoid (SA)",                      index: 209, material: 'a9segmentRight',                 },
  arteryS10:                   {displayName: "Second jejunal (J2A)",              index: 210, material: 'a10segmentRight',                },
  arteryS11:                   {displayName: "Superior mesenteric artery (SMA)",  index: 211, material: 'a1segmentLeft',                  },
  arteryS1Curie:               {displayName: "Art LU a",                          index: 201, material: 'a1segmentRight',                 },
  arteryS2Curie:               {displayName: "Art LU b",                          index: 202, material: 'a2segmentRight',                 },
  arteryS3Curie:               {displayName: "Art LU c",                          index: 203, material: 'a3segmentRight',                 },
  arteryS4Curie:               {displayName: "Art LU d",                          index: 204, material: 'a4segmentRight',                 },
  arteryS5Curie:               {displayName: "Art LU e",                          index: 205, material: 'a5segmentRight',                 },
  arteryS6Curie:               {displayName: "Art LU f",                          index: 206, material: 'a6segmentRight',                 },
  arteryS7Curie:               {displayName: "Art LU g",                          index: 207, material: 'a7segmentRight',                 },
  arteryS8Curie:               {displayName: "Art LU h",                          index: 208, material: 'a8segmentRight',                 },
  arteryS9Curie:               {displayName: "Art LU i",                          index: 209, material: 'a9segmentRight',                 },
  arteryS10Curie:              {displayName: "Art LU j",                          index: 210, material: 'a10segmentRight',                },
  arteryS11Curie:              {displayName: "Art LL k",                          index: 211, material: 'a1segmentRight',                 },
  arteryS12Curie:              {displayName: "Art LL l",                          index: 212, material: 'a2segmentRight',                 },
  arteryS13Curie:              {displayName: "Art LL m",                          index: 213, material: 'a3segmentRight',                 },
  arteryS14Curie:              {displayName: "Art LL n",                          index: 214, material: 'a4segmentRight',                 },
  arteryS15Curie:              {displayName: "Art LL o",                          index: 215, material: 'a5segmentRight',                 },
  arteryS16Curie:              {displayName: "Art LL p",                          index: 216, material: 'a6segmentRight',                 },
  arteryS17Curie:              {displayName: "Art LL q",                          index: 217, material: 'a7segmentRight',                 },
  arteryS18Curie:              {displayName: "Art LL r",                          index: 218, material: 'a8segmentRight',                 },
  arteryS19Curie:              {displayName: "Art LL s",                          index: 219, material: 'a9segmentRight',                 },
  arteryS20Curie:              {displayName: "Art LL t",                          index: 220, material: 'a10segmentRight',                },
  arteryS21Curie:              {displayName: "Art RU a",                          index: 221, material: 'a1segmentRight',                 },
  arteryS22Curie:              {displayName: "Art RU b",                          index: 222, material: 'a2segmentRight',                 },
  arteryS23Curie:              {displayName: "Art RU c",                          index: 223, material: 'a3segmentRight',                 },
  arteryS24Curie:              {displayName: "Art RU d",                          index: 224, material: 'a4segmentRight',                 },
  arteryS25Curie:              {displayName: "Art RU e",                          index: 225, material: 'a5segmentRight',                 },
  arteryS26Curie:              {displayName: "Art RU f",                          index: 226, material: 'a6segmentRight',                 },
  arteryS27Curie:              {displayName: "Art RU g",                          index: 227, material: 'a7segmentRight',                 },
  arteryS28Curie:              {displayName: "Art RU h",                          index: 228, material: 'a8segmentRight',                 },
  arteryS29Curie:              {displayName: "Art RU i",                          index: 229, material: 'a9segmentRight',                 },
  arteryS30Curie:              {displayName: "Art RU j",                          index: 230, material: 'a10segmentRight',                },
  arteryS31Curie:              {displayName: "Art RM k",                          index: 231, material: 'a1segmentRight',                 },
  arteryS32Curie:              {displayName: "Art RM l",                          index: 232, material: 'a2segmentRight',                 },
  arteryS33Curie:              {displayName: "Art RM m",                          index: 233, material: 'a3segmentRight',                 },
  arteryS34Curie:              {displayName: "Art RM n",                          index: 234, material: 'a4segmentRight',                 },
  arteryS35Curie:              {displayName: "Art RM o",                          index: 235, material: 'a5segmentRight',                 },
  arteryS36Curie:              {displayName: "Art RM \u0398",                     index: 236, material: 'a6segmentRight',                 },
  arteryS37Curie:              {displayName: "Art RM \u03B2",                     index: 237, material: 'a7segmentRight',                 },
  arteryS38Curie:              {displayName: "Art RM \u039B",                     index: 238, material: 'a8segmentRight',                 },
  arteryS39Curie:              {displayName: "Art RM \u03A9",                     index: 239, material: 'a9segmentRight',                 },
  arteryS40Curie:              {displayName: "Art RM \u03B1",                     index: 240, material: 'a10segmentRight',                },
  arteryS41Curie:              {displayName: "Art RL p",                          index: 241, material: 'a1segmentRight',                 },
  arteryS42Curie:              {displayName: "Art RL q",                          index: 242, material: 'a2segmentRight',                 },
  arteryS43Curie:              {displayName: "Art RL r",                          index: 243, material: 'a3segmentRight',                 },
  arteryS44Curie:              {displayName: "Art RL s",                          index: 244, material: 'a4segmentRight',                 },
  arteryS45Curie:              {displayName: "Art RL t",                          index: 245, material: 'a5segmentRight',                 },
  arteryS46Curie:              {displayName: "Art RL u",                          index: 246, material: 'a6segmentRight',                 },
  arteryS47Curie:              {displayName: "Art RL v",                          index: 247, material: 'a7segmentRight',                 },
  arteryS48Curie:              {displayName: "Art RL w",                          index: 248, material: 'a8segmentRight',                 },
  arteryS49Curie:              {displayName: "Art RL x",                          index: 249, material: 'a9segmentRight',                 },
  arteryS50Curie:              {displayName: "Art RL y",                          index: 250, material: 'a10segmentRight',                },
  veinS1:                      {displayName: "Inferior mesenteric (IMV)",         index: 221, material: 'v1segment',                      },
  veinS2:                      {displayName: "First jejunal (J1V)",               index: 222, material: 'v2segment',                      },
  veinS3:                      {displayName: "Middle Colic (MCV)",                index: 223, material: 'v3segment',                      },
  veinS4:                      {displayName: "Right gastroepiploic (RGEV)",       index: 224, material: 'v4segment',                      },
  veinS5:                      {displayName: "Ilecolic (ICV)",                    index: 225, material: 'v5segment',                      },
  veinS6:                      {displayName: "Henle (GTH)",                       index: 226, material: 'v6segment',                      },
  veinS7:                      {displayName: "Second jejunal (J2V)",              index: 227, material: 'v7segment',                      },
  veinS8:                      {displayName: "Ileal (IL)",                        index: 228, material: 'v8segment',                      },
  veinS9:                      {displayName: "Third jejunal (J3V)",               index: 229, material: 'v9segment',                      },
  veinS10:                     {displayName: "Inferior pancreatoduodenal (IPDV)", index: 230, material: 'v10segment',                     },
  veinS11:                     {displayName: "Superior mesenteric vein (SMV)",    index: 231, material: 'v11segment',                     },
  veinS12:                     {displayName: "Right colic vein (RCV)",            index: 232, material: 'v12segment',                     },
  lobeKidney:                  {displayName: "Lobe Kidney (segments)",            index: 240, material: 'kidneyBrown',                    },
  portalVeinS1:                {displayName: "PV1",                               index: 241, material: 'v1segment',                      },
  portalVeinS2:                {displayName: "PV2",                               index: 242, material: 'v2segment',                      },
  portalVeinS3:                {displayName: "PV3",                               index: 243, material: 'v3segment',                      },
  portalVeinS4a:               {displayName: "PV4a",                              index: 244, material: 'v4segment',                      },
  portalVeinS4b:               {displayName: "PV4b",                              index: 245, material: 'v5segment',                      },
  portalVeinS5:                {displayName: "PV5",                               index: 246, material: 'v6segment',                      },
  portalVeinS6:                {displayName: "PV6",                               index: 247, material: 'v7segment',                      },
  portalVeinS7:                {displayName: "PV7",                               index: 248, material: 'v8segment',                      },
  portalVeinS8:                {displayName: "PV8",                               index: 249, material: 'v9segment',                      },
  urine:                       {displayName: "Urine",                             index: 250, material: 'kidneyBrown',                    },
} as const

// This next line is only to enforce Record<?, TissueLabel> for TISSUE_LABELS i.e. that each value is a valid TissueLabel.
// Slightly less powerful than setting the type of each individual value, because it doesn't flag extraneous properties.
// This means that it won't catch misspellings of optional properties.
// eslint-able-next-line @typescript-eslint/no-unused-vars
const _dummyTissueLabels: Record<string, TissueLabelParams> = TISSUE_LABEL_PARAMSS

export type TissueLabelName = keyof typeof TISSUE_LABEL_PARAMSS
export class TissueLabel {
  readonly displayName: string
  readonly material: Material
  readonly index: number
  readonly show: boolean

  constructor(
    readonly name: TissueLabelName,
    {displayName, index, show=true, material}: TissueLabelParams,
  ) {
    this.displayName = displayName
    this.index = index
    this.show = show
    this.material = MATERIALS[material]
  }
}

// adds name to the tissue label itself, for convenience
export const TISSUE_LABELS = Object.fromEntries(
  Object.entries(TISSUE_LABEL_PARAMSS).map(([name, bp]) => [name, new TissueLabel(name as TissueLabelName, bp)])
) as Readonly<Record<TissueLabelName, TissueLabel>>
export const TISSUE_LABEL_NAMES = Object.keys(TISSUE_LABELS) as readonly TissueLabelName[]
